import React from 'react';
import { AlertCircle } from 'react-feather';
import { Theme, seismicTheme, Toggle } from '@seismic/mantle';
import { Text, TEXT_VARIANTS } from 'components/ui/Typography';
import request from 'utils/request_ajax';
import { Button, ButtonGroup } from 'components/ui';
import { routes } from 'constants/config';
import Modal from './modal';
import { useAutoFocus, useToggle } from './hooks';
import ReactHtml from './ReactHtml';

const ToggleButton = props => {
  const {
    questionId,
    progressId,
    enabledAutomatedAnalysis,
    setEnabledAutomatedAnalysis,
    disabled,
  } = props;
  const [modalVisible, toggleModalVisible] = useToggle();
  const autoFocus = useAutoFocus();

  const saveAutomatedAnalysis = data => {
    setEnabledAutomatedAnalysis(data);

    request
      .post(routes.ANSWER, {
        answer: {
          enable_automated_analysis: data,
          progress_id: progressId,
          question_id: questionId,
        },
      })
      .catch(e => {
        console.error(e);
        // TODO: Handle Server Error
      });
  };

  const ComplianceModal = () => {
    return enabledAutomatedAnalysis ? (
      <Modal
        show={modalVisible}
        dismissCallback={toggleModalVisible}
        title={t('automated_analysis.privacy_policy.turn_off_header_text')}
        containerClassName="fz-16 lh-26 pt-0"
        headerClassName="bb-0 fz-18 pb-0 c-transparent-background"
      >
        <div className="mb-24">
          {t('automated_analysis.privacy_policy.turn_off_compliance_text')}
        </div>
        <ButtonGroup alignEnd>
          <Button
            primary
            ref={autoFocus}
            onClick={() => {
              toggleModalVisible();
              saveAutomatedAnalysis(!enabledAutomatedAnalysis);
            }}
          >
            {t('automated_analysis.privacy_policy.turn_off')}
          </Button>
          <Button onClick={toggleModalVisible}>{t('common.cancel')}</Button>
        </ButtonGroup>
      </Modal>
    ) : (
      <Modal
        show={modalVisible}
        dismissCallback={toggleModalVisible}
        title={t('automated_analysis.privacy_policy.turn_on_header_text')}
        containerClassName="maxh-600 fz-16 mw-700 lh-26 pt-0"
        headerClassName="bb-0 fz-18 pb-0 c-transparent-background"
      >
        <div className="mb-24">
          <ReactHtml>
            {t('automated_analysis.privacy_policy.turn_on_compliance_text')}
          </ReactHtml>
        </div>
        <ButtonGroup alignEnd>
          <Button
            primary
            ref={autoFocus}
            onClick={() => {
              toggleModalVisible();
              saveAutomatedAnalysis(!enabledAutomatedAnalysis);
            }}
          >
            {t('automated_analysis.privacy_policy.turn_on')}
          </Button>
          <Button onClick={toggleModalVisible}>{t('common.cancel')}</Button>
        </ButtonGroup>
      </Modal>
    );
  };

  return (
    <>
      <div className="d-f Recorder--AutomatedAnalysis">
        <AlertCircle width={24} height={24} />
        <Text
          variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
          className="mt-18 mb-16 ml-8"
        >
          {t('automated_analysis.privacy_policy.text')}
        </Text>
        <Text
          variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
          className="mt-20 mr-10"
        >
          {enabledAutomatedAnalysis
            ? t('automated_analysis.privacy_policy.on')
            : t('automated_analysis.privacy_policy.off')}
        </Text>
        <Theme
          theme={seismicTheme({
            useGlobal: true,
          })}
        >
          <Toggle
            aria-label="Radio Button"
            checked={enabledAutomatedAnalysis}
            onChange={toggleModalVisible}
            disabled={disabled}
          />
        </Theme>
      </div>
      <ComplianceModal />
    </>
  );
};

export default ToggleButton;
